import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { getCancelSharingPath } from '../api'

export const useCancelSharing = () => {
  const { fetcher, isFetching: isCancelling } = useFetch<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })

  const cancelSharing = (sharingId: string) => {
    return fetcher(getCancelSharingPath(sharingId))
  }

  return { cancelSharing, isCancelling }
}
